import PageBack from "@/components/PageBack";
import { MAX_WIDTH } from "@/constant/Constant";
import {
  Box,
  Stack,
  useTheme
} from '@mui/material';
import { useNavigate } from "react-router-dom";

const SimpleHeader = ({ title, backEnable = true, onBackClick, leading, action, transparentBg = false, closeButton, ...props }) => {
  const navigate = useNavigate()
  const theme = useTheme();

  return <Box sx={{ width: '100%', height: '50px', flexShrink: 0 }}>
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ width: '100%', maxWidth: MAX_WIDTH, height: '50px', position: 'fixed', padding: '0 16px', zIndex: 1,
        backgroundColor: transparentBg ? 'transparent' : theme.palette.background.default,
        ...props.sx
      }}
    >
      {backEnable && (
        <div style={{position: 'absolute', left: 0, padding: '0 16px'}}>
          {closeButton ? closeButton : <PageBack onClick={onBackClick} />}
        </div>
      )}

      {leading && <div style={{position: 'absolute', left: 0, padding: '0 16px'}}>
        {leading}
      </div>}

      <p className={'h6'}>{title ?? ''}</p>

      {!!action && <Stack alignItems={'center'} justifyContent={'center'} style={{
        position: 'absolute',
        height: '50px',
        right: '0',
        padding: '0 16px'
      }}>
        {action}
      </Stack>}
    </Stack>
  </Box>;
}

export default SimpleHeader